const red = {
  50: "#F7E7E6",
  100: "#EFCFCE",
  200: "#E7B6B4",
  300: "#DF9E9C",
  400: "#D78683",
  500: "#CF6E6B",
  600: "#C75652",
  // 700 and above text is WCAG AA accessible on white backgrounds.
  700: "#BF3E3A",
  800: "#B72620",
  // 900 text is WCAG AAA accessible on white backgrounds.
  900: "#AF0E08"
};

export default red;
